import React from 'react';
import {
  CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { CourtMartialChargeItemModel } from 'forms/sections/military/disciplinary/types';
import { setAttribute } from 'components/Form/shared/setAttribute';
import CourtMartialCharge from './CourtMartialCharge';

interface Props extends ValidationElementProps {
  $index?: number;
  attribute?: string;
  bind?: boolean;
  className?: string;
  formType?: string;
  name: string;
  onError?: CommonOnError;
  onUpdate?: (value: Partial<CourtMartialChargeItemModel>) => void;
  required?: CommonRequired;
  scrollIntoView?: CommonScrollIntoView;
}

interface ItemProps
  extends Props,
  Partial<CourtMartialChargeItemModel> {}

export default class CourtMartialChargeCollectionItem extends ValidationElement<ItemProps> {
  static defaultProps: ItemProps = {
    ConsequencesExplanation: {} as CourtMartialChargeItemModel['ConsequencesExplanation'],
    CourtMartialChargeDescription: {} as CourtMartialChargeItemModel['CourtMartialChargeDescription'],
    Has: {} as CourtMartialChargeItemModel['Has'],
    ImprisonedWhen: {} as CourtMartialChargeItemModel['ImprisonedWhen'],
    OutcomeConsequences: {} as CourtMartialChargeItemModel['OutcomeConsequences'],
    OutcomeExplanation: {} as CourtMartialChargeItemModel['OutcomeExplanation'],
    OutcomeType: {} as CourtMartialChargeItemModel['OutcomeType'],
    ParoleGranted: {} as CourtMartialChargeItemModel['ParoleGranted'],
    ParoleWhen: {} as CourtMartialChargeItemModel['ParoleWhen'],
    // non-Model properties below
    name: '',
  };

  update = (queue: Partial<CourtMartialChargeItemModel>) => {
    if (this.props.onUpdate) {
      this.props.onUpdate({
        ConsequencesExplanation: this.props.ConsequencesExplanation,
        CourtMartialChargeDescription: this.props.CourtMartialChargeDescription,
        Has: this.props.Has,
        ImprisonedWhen: this.props.ImprisonedWhen,
        OutcomeConsequences: this.props.OutcomeConsequences,
        OutcomeExplanation: this.props.OutcomeExplanation,
        OutcomeType: this.props.OutcomeType,
        ParoleGranted: this.props.ParoleGranted,
        ParoleWhen: this.props.ParoleWhen,
        ...queue,
      });
    }
  };

  onUpdateList = (values: Partial<CourtMartialChargeItemModel>) => {
    this.update({ ...values });
  };

  render() {
    const attribute: string | undefined = setAttribute(this.props.attribute, `items[${this.props.$index}].Item`);

    return (
      <CourtMartialCharge
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        attribute={attribute}
        bind
        formType={this.props.formType}
        name="Item"
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        onError={this.props.onError}
        onUpdate={this.onUpdateList}
        required={this.props.required}
      />
    );
  }
}
